import {IAccConfigInvoiceActionTypes} from "../../action-types/category/IAccConfigInvoiceActions";
import {IAccConfigInvoiceReducer} from "../../reducer-model/category/IAccConfigInvoiceReducer";
import {eReducerStatusBase} from "../../reducer-model/eReducerStatusBase";

const iniState: IAccConfigInvoiceReducer = {
    status: eReducerStatusBase.is_not_initialization,
    configInvoices: [],
    idSelections: [],
};
export const configInvoiceReducer = (
    state: IAccConfigInvoiceReducer = iniState,
    action: IAccConfigInvoiceActionTypes
): IAccConfigInvoiceReducer => {
    switch (action.type) {
        case "CONFIG_INVOICE_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                idSelections: [],
            };
        case "CONFIG_INVOICE_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                configInvoices: action.payload?.filter((g) => g.is_active),
            };
        case "CONFIG_INVOICE_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CONFIG_INVOICE_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "CONFIG_INVOICE_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "CONFIG_INVOICE_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CONFIG_INVOICE_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CONFIG_INVOICE_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CONFIG_INVOICE_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CONFIG_INVOICE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                configInvoiceEditing: action.payload,
            };
        case "CONFIG_INVOICE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                configInvoiceEditing: undefined,
            };
        case "CONFIG_INVOICE_SELECTED_ID":
            return {
                ...state,
                idSelections: action.payload,
            };
        case "CONFIG_INVOICE_DELETE_MANY_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CONFIG_INVOICE_DELETE_MANY_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CONFIG_INVOICE_DELETE_MANY_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
};
